import Resource from "./resource";

export class MaintenanceConfigurationResource extends Resource {
    IsInMaintenanceMode: boolean;
}

export default MaintenanceConfigurationResource;